import { getAxiosResponseData, APIClients } from '@futrli/shared-services';

// This is where the real types live:
// import { paths as orgServicePaths } from '@sage/sbc.core.organisation.service.types';
// export type SceneData = orgServicePaths['/v1/users/login']['post']['responses']['200']['content']['application/json'];

export interface SceneData {
  Account: Record<string, string>;
  ProductInstance: {
    UrlsConfiguration: Record<string, string | null>;
  };
  User: {
    Id: string;
    Locale: string;
  };
}

export interface UserConsentData {
  AtLeastOneReconsent: boolean;
  Purposes: UserConsentPurpose[];
  ConsentOptionsAvailable: {
    OptionNameKey: string;
  }[];
  PrivacyPolicyUrl: string;
  CookiePolicyUrl: string;
  CountryCode: string;
  PreferencesUrl: string;
}

interface UserConsentPurpose {
  Id: string;
  Label: string;
  Description: string;
  Accepted: boolean;
  IsAlreadyConsentedOrNot: boolean;
  MustReconsent: boolean;
  Version: number;
}

/**
 * Fetches and returns the scene data for a user
 */
export const fetchSceneData = async (businessId?: string): Promise<SceneData | undefined> => {
  if (window.__sbc_config) {
    const path = `/v1/users/login?Keys=IsMultiFactorAuthenticated&Keys=LandInHome&Keys=MshBusinessAccordionExpanded`;
    const response = await APIClients.getAPIClient().makeRequest({
      payload: {
        request: {
          baseURL: window.__sbc_config.api['sbc.core.organisation.service'].href,
          method: 'POST',
          url: path,
          data: {
            BusinessId: businessId,
            ProductCode: 'futrli',
            Platform: 'Sage'
          }
        }
      },
      sxp: true
    });

    return getAxiosResponseData(response);
  }
};

/**
 * Fetches and returns the given users consent preference data
 * @param userId - The ID of the user to fetch the consent preferences for
 */
export const fetchUserConsentData = async (userId: string): Promise<UserConsentData | undefined> => {
  if (window.__sbc_config) {
    const path = `/v1/users/${userId}/consent`;
    const response = await APIClients.getAPIClient().makeRequest({
      payload: {
        request: {
          baseURL: window.__sbc_config.api['sbc.core.globalnav.app'].href,
          method: 'GET',
          url: path
        }
      },
      sxp: true
    });

    return getAxiosResponseData(response);
  }
};
